
<style type="text/css">
  .pdf__tabletotal-company img {
  align-self: center;
}
</style>
@if (!pdfDoc) {
  <link  [href]="printPdfCssHref" media="print" rel="stylesheet"/>
}
@if (pdfDoc) {
  <link [href]="printPdfCssHref" media="all" rel="stylesheet"/>
}
@if (pdfDoc) {
  <nav class="navbar navbar--central navbar--screen-view fixed-top" style="top: 0px;">
    <!-- Logo in nav bar -->
    <div class="container-fluid">
      <div class="navbar-policy">
        <div class="navbar-policy__breadcrumbs d-none d-lg-flex">
          <a>Quote Schedule</a>
        </div>
        <a href="javascript:;" (click)="closePDFNav()"  class="navbar-policy__close icon-hover" data-tooltip="tooltip" data-placement="bottom" title="" data-original-title="Close">
          <svg class="icon">
            <use xlink:href="#close-medium"></use>
          </svg>
        </a>
        <div class="navbar-policy__nav d-lg-none">
          <div class="navbar-policy__nav-current"><strong>Quote Schedule</strong></div>
        </div>
      </div>
    </div>
  </nav>
}
@if (!pdfDoc) {
  <nav class="navbar navbar--central fixed-top">
    <!-- Logo in nav bar -->
    <div class="container-fluid">
      <div class="navbar-sub">
        <a href="javascript:;" (click)="closeSchedule()" class="navbar-sub__back">
          <svg class="icon">
            <use xlink:href="#arrow-left-small"></use>
          </svg>
        </a>
        <div class="navbar-sub__nav text-left">
          Quote schedule
        </div>
        <div class="navbar-sub__more">
          <div class="navbar-sub__search">
            <div class="navbar-sub__search-trigger icon-hover icon-hover--alt" id="search-trigger">
              <svg class="icon">
                <use xlink:href="#search"></use>
              </svg>
            </div>
            <div class="navbar-sub__search-container" id="search-container">
              <div class="form-control__wrap has-clear">
                <input type="search" placeholder="Search" id="search-input" autocomplete="off" class="form-control form-control--sm">
                <a href="#" id="search-clear" class="form-control__clear"><svg class="icon">
                  <use xlink:href="#close-circle-small"></use>
                </svg></a>
              </div>
              <div class="navbar-sub__search-up" title="Prev">
                <svg class="icon">
                  <use xlink:href="#dropdown-up-medium"></use>
                </svg>
              </div>
              <div class="navbar-sub__search-down" title="Next">
                <svg class="icon">
                  <use xlink:href="#dropdown-down-medium"></use>
                </svg>
              </div>
            </div>
            <a href="#" class="navbar-sub__search-close icon-hover icon-hover--alt" id="search-close">
              <svg class="icon">
                <use xlink:href="#close-medium"></use>
              </svg>
            </a>
          </div>
          <div class="navbar-sub__share">
            <a href="#modal-share-menu" data-toggle="modal" class="icon-hover icon-hover--alt d-lg-none">
              <svg class="icon">
                <use xlink:href="#share"></use>
              </svg>
            </a>
            <div class="dropdown d-none d-lg-block">
              <a href="#" class="icon-hover icon-hover--alt dropdown-toggle dropdown-toggle--nocaret" data-toggle="dropdown" id="shareDropdown" aria-expanded="false">
                <svg class="icon">
                  <use xlink:href="#share"></use>
                </svg>
              </a>
              <div class="dropdown-menu dropdown-menu-right">
                <div class="profile-drop">
                  <div class="profile-drop__inner">
                    <ul class="profile-drop__list list-unstyled">
                      <li>
                        <a href="javascript:;" (click)="download()">
                          <svg class="icon">
                            <use xlink:href="#download"></use>
                          </svg>
                          <span>Download</span>
                        </a>
                      </li>
                      <!-- <li>
                      <a href="#share-email-modal" data-toggle="modal" target="_blank">
                        <svg class="icon">
                          <use xlink:href="#envelope"></use>
                        </svg>
                        <span>Email</span>
                      </a>
                    </li> -->
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="navbar-sub__support">
          <div class="navbar-actions__chat dropdown dropdown--persist" id="chatDropdown">
            <a href="#" role="button" id="chatTrigger" data-toggle="dropdown" title="Chat" aria-haspopup="true" aria-expanded="false">
              <span class="d-none d-lg-inline">Help</span>
              <svg class="icon d-lg-none">
                <use xlink:href="#chat"></use>
              </svg>
              <svg class="icon d-none d-lg-inline-block">
                <use xlink:href="#chat"></use>
              </svg>
            </a>
            <div class="dropdown-menu dropdown-menu--chat" aria-labelledby="chatTrigger">
              <div class="chat-info has-emergency">
                <div class="container">
                  <div class="chat-info__avatar">
                    <img src="assets/0/avatar/happy.png" class="img-fluid" alt="">
                  </div>
                  <div class="chat-info__content">
                    <h5>Hi 👋! How can we help?</h5>
                    <p>Start chatting with the next available agent, or if you prefer a friendly voice our
                    licensed Everything.Insure brokers are ready to assist.</p>
                    <a href="#" class="button button--primary">Start Chat</a>
                  </div>
                  <div class="chat-info__close dropdown-close">
                    <svg class="icon">
                      <use xlink:href="#close-circle-small"></use>
                    </svg>
                  </div>
                </div>
                <div class="chat-info__accordion accordion accordion--sm" id="accordion-help">
                  <div class="container">
                    <div class="accordion__item">
                      <a href="#help-1" class="accordion__title collapsed" data-toggle="collapse" aria-expanded="false">
                        <div class="accordion__title-text">
                          <h6>We can create a quote for you</h6>
                        </div>
                        <div class="accordion__title-caret">
                          <svg class="icon">
                            <use xlink:href="#chevron-down-smaller"></use>
                          </svg>
                        </div>
                      </a>
                      <div class="accordion__body collapse" id="help-1" data-parent="#accordion-help">
                        <div class="accordion__content">
                          <span class="tag tag--sm tag--free mb-10">Free Service</span>
                          <p>Simply upload a Policy Schedule from a different Insurer and we’ll use that
                            to
                          build a new quote for you!</p>
                          <p>
                            <a href="#create-quote-modal" data-toggle="modal" class="button-control button-control--tight">
                              <svg class="icon icon--sm">
                                <use xlink:href="#upload"></use>
                                </svg><strong>Upload Schedule</strong>
                              </a>
                            </p>
                          </div>
                        </div>
                      </div>
                      <div class="accordion__item">
                        <a href="#help-2" class="accordion__title collapsed" data-toggle="collapse" aria-expanded="false">
                          <div class="accordion__title-text">
                            <h6>Chat to a broker</h6>
                          </div>
                          <div class="accordion__title-caret">
                            <svg class="icon">
                              <use xlink:href="#chevron-down-smaller"></use>
                            </svg>
                          </div>
                        </a>
                        <div class="accordion__body collapse" id="help-2" data-parent="#accordion-help">
                          <div class="accordion__content">
                            <p>Our licensed Everything.Insure brokers are ready to help you. Please get in
                            touch.</p>
                            <p class="chat-info__accordion-call">
                              <svg class="icon icon--sm">
                                <use xlink:href="#phone-filled"></use>
                              </svg>
                              <strong class="font-16">011 510 1300</strong>
                              <span>or</span>
                              <a href="#request-call-modal" data-toggle="modal"><strong>Request a
                              Call</strong></a>
                            </p>
                          </div>
                        </div>
                      </div>
                      <div class="accordion__item">
                        <a href="#" class="accordion__title collapsed">
                          <div class="accordion__title-text">
                            <h6>Let us help you</h6>
                          </div>
                          <div class="accordion__title-caret">
                            <svg class="icon">
                              <use xlink:href="#chevron-right-small"></use>
                            </svg>
                          </div>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="chat-info__emergency">
                  <a href="https://www.everything.insure/pages/everything.login.html" target="_blank">
                    <svg class="icon">
                      <use xlink:href="#navigation-sos"></use>
                    </svg>
                    Emergency services
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div class="navbar-sub__close d-none d-lg-block">
            <a href="javascript:;" (click)="closeSchedule()" data-toggle="modal" class="icon-hover icon-hover--alt">
              <svg class="icon">
                <use xlink:href="#close-medium"></use>
              </svg>
            </a>
          </div>
        </div>
      </div>
    </div>
  </nav>
}
@if (!pdfDoc) {
  <div class="breadcrumbs">
    <ul class="breadcrumbs__list">
      @if (!fromQuotePage) {
        <li><a href="javascript:;" [routerLink]="'/' + RouterLinks.QuoteLanding">Quotes</a></li>
      }
      <li>Quote schedule</li>
    </ul>
  </div>
}

<!-- <div class="loader loader--fs" [ngClass]="{'show': spinner}">
<div class="loader__inner">
  <ng-lottie [options]="options"></ng-lottie>
  <div class="loader__text">
    One moment, please…
  </div>
</div>
</div> -->
<main class="page-main" id="main">
  <div [ngClass]="pdfDoc ? null:'layout layout--central'">
    <div [ngClass]="pdfDoc ? null:'layout__row'">
      @if (!pdfDoc) {
        <div class="layout__sidecol">
          <nav class="central-nav has-scrollto has-burger">
            <ul class="central-nav__list list-unstyled" id="docs-nav">
              <li class="is-spied">
                <a href="#anchor-overview"><span>Overview</span></a>
              </li>
              <li>
                <a href="#anchor-details"><span>Details</span></a>
              </li>
              @if (coverSummary?.length > 0 || policySummaryAlt?.length > 0) {
                <li>
                  <a href="#anchor-quote-summary"><span>Summary of Cover</span></a>
                </li>
              }
              @if (benefitSummary?.length > 0 || benefitSummaryAlt?.length > 0) {
                <li>
                  <a href="#anchor-benefits-summary"><span>Benefits Summary</span></a>
                </li>
              }
              @if (getDistinctDatasetNineClasses().length > 0) {
                <li class="has-sub">
                  <a href="#anchor-insured-items"><span>Insured Items</span></a>
                  <div>
                    <ul>
                      @for (header of getDistinctDatasetNineClasses(); track header) {
                        <li>
                          <a [href]="'#anchor-insured-items-' + constructID(header)">{{header}}</a>
                        </li>
                      }
                    </ul>
                  </div>
                </li>
              }
              @if (hasConditions()) {
                <li>
                  <a href="#anchor-conditions"><span>Conditions</span></a>
                </li>
              }
              @if (checkIfVapsWordingExists()?.length > 0) {
                <li>
                  <a href="#anchor-benefits-conditions"><span>Benefits Conditions</span></a>
                </li>
              }
              <li>
                <a href="#anchor-disclosure-notice"><span>Disclosure Notice</span></a>
              </li>
            </ul>
            <div class="central-nav__burger">
              <svg class="icon">
                <use xlink:href="#menu"></use>
              </svg>
            </div>
          </nav>
        </div>
      }
      <div [ngClass]="pdfDoc ? null:'layout__bodycol'" id="search-body">
        <section [ngClass]="pdfDoc ? 'pdf-page pdf-page--cover': 'pdf-view'" id="anchor-overview" data-title="Overview">
          <div class="pdf-page__component">
            <header class="pdf__coverhead">
              <div class="pdf__coverhead-logo">
                <span><img [src]="firstWhere(header, 'field_key', 'platform_logo')?.value" alt="Everything.Insure"></span>
                <span [class.pdf__coverhead-tagline]="isTaglineLogo(firstWhere(header, 'field_key', 'broker_logo')?.value)"><img [src]="firstWhere(header, 'field_key', 'broker_logo')?.value" alt="Your only insurance platform"></span>
              </div>
              <div class="pdf__coverhead-company">
                <img [src]="firstWhere(header, 'field_key', 'insurer_logo')?.value" class="img-fluid">
              </div>
            </header>
            @if (firstWhere(header, 'field_key', 'underwriter_logo')?.value) {
              <div class="pdf__cover-underwritten">
                <span>Underwritten by</span>
                <div class="pdf__cover-underwritten-logo">
                  <img [src]="firstWhere(header, 'field_key', 'underwriter_logo')?.value" alt="">
                </div>
              </div>
            }
            <div class="pdf__cover-details">
              <h1>Quote Schedule</h1>
              <ul class="list-unstyled">
                @for (field of whereEquals(header, 'value_type', 'text'); track field) {
                  <li>
                    <p>{{field?.label}}</p>
                    <div>{{field?.value}}</div>
                  </li>
                }
              </ul>
            </div>

            <!-- 'did you know' cover element -->
            @if (pdfDoc) {
              <div class="pdf__cover-dyk">
                <img src="assets/img/docs/documents-cover-page.webp" class="pdf__cover-dyk-full">
                <div class="pdf__cover-dyk-content">
                  <h2 class="font-serif">Did you know?</h2>
                  <p>Claiming is quick and easy. You can submit a claim online anytime, anywhere. Stay up-to-date with
                  the status of your claims in real-time.</p>
                  <p>Simply log in to your app, tap the <strong>Start Claim</strong> button and begin the process.</p>
                </div>
              </div>
            }
            <!-- -->
          </div>
        </section>

        @if (pdfDoc) {
          <section class="pdf-page">
            <div class="pdf-page__component" id="anchor-index">
              <header class="pdf__coverhead">
                <div class="pdf__coverhead-title"><h3>Quote Schedule</h3></div>
              </header>
              <div class="pdf__index">
                <ul class="list-unstyled pdf-index"></ul>
              </div>
            </div>
            <footer class="pdf-page__footer">
              <div class="pdf-page__footer-inner">
                <img src="assets/0/logo.svg" alt="Everything.Insure">
                <p><strong>Questions?</strong> Contact Everything.Insure at <a href="mailto:{{footer?.support_email || 'help@everything.insure'}}">{{footer?.support_email || 'help@everything.insure'}}</a> or call <strong>{{footer?.support_phone || '0870952823'}}</strong></p>
                <div><a href="#anchor-index" data-anchor-scroll="">Back to contents</a></div>
                <div><span class="pdf-page-num"></span></div>
              </div>
            </footer>
          </section>
        }


    @if (pdfDoc) {
      <section class="pdf-page pdf-page--section" data-title="Details" id="anchor-details">
        <div class="pdf-page__component">
          <header class="pdf__coverhead">
            <div class="pdf__coverhead-logo">
              <span><img [src]="firstWhere(header, 'field_key', 'platform_logo')?.value"></span>
              <span [class.pdf__coverhead-tagline]="isTaglineLogo(firstWhere(header, 'field_key', 'broker_logo')?.value)"><img [src]="firstWhere(header, 'field_key', 'broker_logo')?.value"></span>
            </div>
            <div class="pdf__coverhead-company">
              <img src="{{firstWhere(header, 'field_key', 'insurer_logo')?.value}}" class="img-fluid">
            </div>
          </header>
          <div class="pdf__cover-section">
            <div class="pdf__cover-section-bg"><img src="assets/img/home/header-everything.svg" alt=""></div>
            <div class="pdf__cover-section-badge"><img src="assets/img/docs/people-details.webp" alt=""></div>
            <div class="pdf__cover-section-spacer"></div>
            <div class="pdf__cover-section-content"><h1>Details</h1></div>
          </div>
        </div>
        <footer class="pdf-page__footer">
          <div class="pdf-page__footer-inner">
            <img src="assets/0/logo.svg" alt="Everything.Insure">
            <p><strong>Questions?</strong> Contact Everything.Insure at <a href="mailto:{{footer?.support_email || 'help@everything.insure'}}">{{footer?.support_email || 'help@everything.insure'}}</a> or call <strong>{{footer?.support_phone || '0870952823'}}</strong></p>
            <div><a href="#anchor-index" data-anchor-scroll="">Back to contents</a></div>
            <div><span class="pdf-page-num"></span></div>
          </div>
        </footer>
      </section>
    }

    <section [ngClass]="pdfDoc ? 'pdf-page': 'pdf-view'" [id]="!pdfDoc ? 'anchor-details' : null" data-title="Details">

      <!-- Details: grouped by subheader from schedule dataset 2 -->
      @for (group of detailsGroups; track group; let i = $index) {
        <div class="pdf-page__component">
          @if (i === 0) {
            <div class="pdf-page__component-title">
              <div class="pdf-page__component-title-text">
                <h2>{{group.rows[0]?.header}}</h2>
              </div>
            </div>
          }
          <div class="pdf__data">
            <div class="pdf__data-title">
              @if (group.key === 'Transaction Details') {
                <img src="assets/icn/products/professional-indemnity.svg" class="icon">
              }
              <h4>{{group.key}}</h4>
            </div>
            <div class="pdf__data-table">
              <ul class="data">
                @for (row of group.rows; track row) {
                  <li class="data__row">
                    @if (row?.label) {
                      <label class="data__label">{{row.label}}</label>
                    }
                    @if (row?.label === 'Status') {
                      <div class="data__cell"><div class="indicator {{getStatusIndicatorClass(row?.value)}}">{{row?.value}}</div></div>
                    } @else if (row?.value_type === 'html') {
                      <div class="data__cell" [innerHTML]="row?.value | safeHtml"></div>
                    } @else {
                      <div class="data__cell">{{row?.value}}</div>
                    }
                  </li>
                }
              </ul>
            </div>
          </div>
        </div>
      }

      <!-- Transaction Details -- pre-bind quotes can have no index=3 rows at all (e.g. before
      a transaction reason/signature exists), so this must not render an empty shell. -->
      @if (transaction?.length > 0) {
        <div class="pdf-page__component">
          <div class="table-pdf-title" data-sticky="true">
            <div class="table-pdf-title__left">
              <img src="assets/icn/products/professional-indemnity.svg" class="icon">
              <h5>{{transaction?.[0]?.header || 'Transaction Details'}}</h5>
            </div>
          </div>
          <div class="table-pdf-wrap">
            <table class="table table--pdf">
              <tbody>
                <tr><td>
                  <ul class="data data--grid data--compact">
                    <li class="data__row">
                      <div class="data__label">{{firstWhere(transaction, 'field_key', 'effective_date')?.label}} <strong>{{firstWhere(transaction, 'field_key', 'effective_date')?.value}}</strong></div>
                      <div class="data__cell">{{firstWhere(transaction, 'field_key', 'date_processed')?.label}} <strong>{{firstWhere(transaction, 'field_key', 'date_processed')?.value}}</strong></div>
                    </li>
                    <li class="data__row">
                      <div class="data__label">{{firstWhere(transaction, 'field_key', 'transaction_reason')?.label}} <strong>{{firstWhere(transaction, 'field_key', 'transaction_reason')?.value}}</strong></div>
                      <div class="data__cell">{{firstWhere(transaction, 'field_key', 'policy_currency')?.label}} <strong>{{firstWhere(transaction, 'field_key', 'policy_currency')?.value}}</strong></div>
                    </li>
                  </ul>
                </td></tr>
              </tbody>
            </table>
          </div>
        </div>
      }

      @if (pdfDoc) {
        <footer class="pdf-page__footer">
          <div class="pdf-page__footer-inner">
            <img src="assets/0/logo.svg" alt="Everything.Insure">
            <p><strong>Questions?</strong> Contact Everything.Insure at <a href="mailto:{{footer?.support_email || 'help@everything.insure'}}">{{footer?.support_email || 'help@everything.insure'}}</a> or call <strong>{{footer?.support_phone || '0870952823'}}</strong></p>
            <div><a href="#anchor-index" data-anchor-scroll="">Back to contents</a></div>
            <div><span class="pdf-page-num"></span></div>
          </div>
        </footer>
      }
    </section>


    @if (pdfDoc && (coverSummary?.length > 0 || policySummaryAlt?.length > 0)) {
      <section class="pdf-page pdf-page--section" data-title="Summary of Cover" id="anchor-quote-summary">
        <div class="pdf-page__component">
          <header class="pdf__coverhead">
            <div class="pdf__coverhead-logo">
              <span><img [src]="firstWhere(header, 'field_key', 'platform_logo')?.value"></span>
              <span [class.pdf__coverhead-tagline]="isTaglineLogo(firstWhere(header, 'field_key', 'broker_logo')?.value)"><img [src]="firstWhere(header, 'field_key', 'broker_logo')?.value"></span>
            </div>
            <div class="pdf__coverhead-company">
              <img src="{{firstWhere(header, 'field_key', 'insurer_logo')?.value}}" class="img-fluid">
            </div>
          </header>
          <div class="pdf__cover-section">
            <div class="pdf__cover-section-bg"><img src="assets/img/home/header-everything.svg" alt=""></div>
            <div class="pdf__cover-section-badge"><img src="assets/img/docs/people-insured-items.webp" alt=""></div>
            <div class="pdf__cover-section-spacer"></div>
            <div class="pdf__cover-section-content"><h1>Summary of Cover</h1></div>
          </div>
        </div>
        <footer class="pdf-page__footer">
          <div class="pdf-page__footer-inner">
            <img src="assets/0/logo.svg" alt="Everything.Insure">
            <p><strong>Questions?</strong> Contact Everything.Insure at <a href="mailto:{{footer?.support_email || 'help@everything.insure'}}">{{footer?.support_email || 'help@everything.insure'}}</a> or call <strong>{{footer?.support_phone || '0870952823'}}</strong></p>
            <div><a href="#anchor-index" data-anchor-scroll="">Back to contents</a></div>
            <div><span class="pdf-page-num"></span></div>
          </div>
        </footer>
      </section>
    }

    @if (coverSummary?.length > 0) {
    <section [ngClass]="pdfDoc ? 'pdf-page': 'pdf-view'" [id]="!pdfDoc ? 'anchor-quote-summary' : null" data-title="Summary of Cover">
      <div class="pdf-page__component">
        <div class="pdf-page__component-title">
          <div class="pdf-page__component-title-text">
            <h2>{{firstWhere(coverSummary, 'entry_type', 'header')?.header || 'Summary of Cover'}}</h2>
          </div>
        </div>
      </div>

      <div class="pdf-page__component">
        <div class="table-pdf-title" data-sticky="true">
          <div class="table-pdf-title__left">
            <img [src]="coverRow('main_cover','header')?.img_path" class="icon"><h5>{{coverRow('main_cover','header')?.detail}}</h5>
          </div>
          <div class="table-pdf-title__right">
            @if (hasConditions() && !pdfDoc) {
              <p>The full list of Conditions can be found <a href="#anchor-conditions" data-scrollto="true" data-scrolltooffset="80">here</a>.</p>
            }
            @if (hasConditions() && pdfDoc) {
              <p>The full list of Conditions can be found on <a href="#anchor-conditions" data-anchor-scroll="">page <span class="pdf-page-x" data-target="anchor-conditions"></span></a>.</p>
            }
          </div>
        </div>
        <div class="table-pdf-wrap">
          <table class="table table--pdf">
            <thead>
              <tr>
                <th class="cell-label">Detail</th>
                <th>Provider</th>
                @if (summaryHasColumn(coverSummary, 'limit')) {
                  <th class="cell-centered">Limit</th>
                }
                @if (summaryHasColumn(coverSummary, 'basis')) {
                  <th class="cell-centered">Basis</th>
                }
                <th class="cell-centered">Excess</th>
                <th class="cell-right">Premium</th>
              </tr>
            </thead>
            <tbody>
              @if (coverRow('policy','sub_header')) {
                <tr>
                  <th [attr.colspan]="summaryColspan(coverSummary)" class="cell-pdf-sub">
                    <div class="table-label">
                      <img [src]="coverRow('policy','sub_header')?.img_path" class="icon"> {{coverRow('policy','sub_header')?.detail}}
                    </div>
                  </th>
                </tr>
              }
              @for (item of coverRows('policy','entity'); track item) {
                <tr>
                  <td class="cell-label cell-medium">{{item?.detail}}</td>
                  <td>{{item?.provider}}</td>
                  @if (summaryHasColumn(coverSummary, 'limit')) {
                    <td class="cell-centered">{{item?.limit}}</td>
                  }
                  @if (summaryHasColumn(coverSummary, 'basis')) {
                    <td class="cell-centered">{{item?.basis}}</td>
                  }
                  <td class="cell-centered">{{item?.excess}}</td>
                  <td class="cell-right cell-value"><strong>{{item?.premium}}</strong>/{{item?.frequency_short}}</td>
                </tr>
              }
              @if (coverRow('class','sub_header')) {
                <tr>
                  <th [attr.colspan]="summaryColspan(coverSummary)" class="cell-pdf-sub">
                    <div class="table-label">
                      <img [src]="coverRow('class','sub_header')?.img_path" class="icon"> {{coverRow('class','sub_header')?.detail}}
                    </div>
                  </th>
                </tr>
              }
              @for (item of coverRows('class','entity'); track item) {
                <tr>
                  <td class="cell-label cell-medium">
                    <div class="table-label">
                      <img [src]="item?.img_path" class="icon"> {{item?.detail}}
                    </div>
                  </td>
                  <td>{{item?.provider}}</td>
                  @if (summaryHasColumn(coverSummary, 'limit')) {
                    <td class="cell-centered">{{item?.limit}}</td>
                  }
                  @if (summaryHasColumn(coverSummary, 'basis')) {
                    <td class="cell-centered">{{item?.basis}}</td>
                  }
                  <td class="cell-centered">{{item?.excess}}</td>
                  <td class="cell-right cell-value"><strong>{{item?.premium}}</strong>/{{item?.frequency_short}}</td>
                </tr>
              }
              @if (summaryHasColumn(coverSummary, 'limit') && coverRow('note','entity')?.detail) {
                <tr>
                  <td class="cell-note" [attr.colspan]="summaryColspan(coverSummary)">
                    <p><strong>Note:</strong> {{coverRow('note','entity')?.detail}}</p>
                  </td>
                </tr>
              }
            </tbody>
          </table>
        </div>
      </div>

      <div class="pdf-page__component">
        <div class="table-pdf-title" data-sticky="true">
          <div class="table-pdf-title__left">
            <img [src]="coverRow('premium','header')?.img_path" class="icon"><h5>{{coverRow('premium','header')?.detail}}</h5>
          </div>
        </div>
        <div class="pdf__tabletotal">
          <div class="pdf__tabletotal-inner">
            <div class="pdf__tabletotal-subtotals">
              <div class="pdf__tabletotal-company">
                <img [src]="coverRow('premium','logo')?.img_path || firstWhere(header, 'field_key', 'insurer_logo')?.value" class="img-fluid">
              </div>
              <div class="pdf__tabletotal-subtotal">
                <label>{{coverRow('premium','items_subtotal')?.detail}}</label>
                <p><strong>{{coverRow('premium','items_subtotal')?.premium}}</strong><wbr>/{{coverRow('premium','items_subtotal')?.frequency_short}}</p>
              </div>
              @if (coverRow('premium','benefits_subtotal')) {
                <div class="pdf__tabletotal-subtotal">
                  <label>{{coverRow('premium','benefits_subtotal')?.detail}}</label>
                  <p><strong>{{coverRow('premium','benefits_subtotal')?.premium}}</strong><wbr>/{{coverRow('premium','benefits_subtotal')?.frequency_short}}</p>
                </div>
              }
              @if (coverRow('premium','fees_subtotal')) {
                <div class="pdf__tabletotal-subtotal">
                  <label>{{coverRow('premium','fees_subtotal')?.detail}}</label>
                  <p><strong>{{coverRow('premium','fees_subtotal')?.premium}}</strong><wbr>/{{coverRow('premium','fees_subtotal')?.frequency_short}}</p>
                </div>
              }
              @if (coverRow('premium','sasria_subtotal')) {
                <div class="pdf__tabletotal-subtotal">
                  <label>{{coverRow('premium','sasria_subtotal')?.detail}}</label>
                  <p><strong>{{coverRow('premium','sasria_subtotal')?.premium}}</strong><wbr>/{{coverRow('premium','sasria_subtotal')?.frequency_short}}</p>
                </div>
              }
            </div>
            <div class="pdf__tabletotal-total">
              <div class="pdf__tabletotal-label">
                <label>{{coverRow('premium','policy_premium_total')?.detail}}</label>
              </div>
              <div class="pdf__tabletotal-details">
                <div class="pdf__tabletotal-cost">
                  <p><strong>{{coverRow('premium','policy_premium_total')?.premium}}</strong><wbr>/{{coverRow('premium','policy_premium_total')?.frequency_short}}</p>
                </div>
                <div class="pdf__tabletotal-text">
                  <small>{{coverRow('premium','taxes')?.detail}}<strong>{{coverRow('premium','taxes')?.premium}}</strong></small>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      @if (pdfDoc) {
        <footer class="pdf-page__footer">
          <div class="pdf-page__footer-inner">
            <img src="assets/0/logo.svg" alt="Everything.Insure">
            <p><strong>Questions?</strong> Contact Everything.Insure at <a href="mailto:{{footer?.support_email || 'help@everything.insure'}}">{{footer?.support_email || 'help@everything.insure'}}</a> or call <strong>{{footer?.support_phone || '0870952823'}}</strong></p>
            <div><a href="#anchor-index" data-anchor-scroll="">Back to contents</a></div>
            <div><span class="pdf-page-num"></span></div>
          </div>
        </footer>
      }
    </section>
    }

    <!-- Quote Summary Alternate: same card, class rows expanded into one row per item -->
    @if (policySummaryAlt?.length > 0) {
    <section [ngClass]="pdfDoc ? 'pdf-page': 'pdf-view'" [id]="(!pdfDoc && !coverSummary?.length) ? 'anchor-quote-summary' : null" data-title="Summary of Cover">
      <div class="pdf-page__component">
        <div class="pdf-page__component-title">
          <div class="pdf-page__component-title-text">
            <h2>{{coverAltRow('main_cover','header')?.header || 'Summary of Cover'}}</h2>
          </div>
        </div>
      </div>

      @if (isSimpleSchedule()) {
        <!-- Simple: one card per item, its curated attributes underneath -->
        @for (item of getSummaryCardItems(); track item.class_id + '|' + item.item_id) {
          <div class="pdf-page__component">
            <div class="table-pdf-title">
              <div class="table-pdf-title__left">
                <img [src]="item?.img_path" alt="" class="icon" />
                <h5>{{item?.detail}}</h5>
              </div>
              <div class="table-pdf-title__right">
                <p class="price"><strong>{{item?.premium}}</strong>/{{item?.frequency_short}}</p>
              </div>
            </div>
            @if (getSummaryCardFields(item); as fields) {
              @if (fields.length > 0) {
                <div class="table-pdf-wrap">
                  <table class="table table--pdf">
                    <tbody>
                      <tr>
                        <td>
                          <ul class="data">
                            @for (field of fields; track $index) {
                              <li class="data__row">
                                <label class="data__label" [innerHTML]="field?.label"></label>
                                <div class="data__cell" style="white-space: pre-line">{{field?.detail}}</div>
                              </li>
                            }
                          </ul>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              }
            }
          </div>
        }
      } @else {
      <div class="pdf-page__component">
        <div class="table-pdf-title" data-sticky="true">
          <div class="table-pdf-title__left">
            <img [src]="coverAltRow('main_cover','header')?.img_path" class="icon"><h5>{{coverAltRow('main_cover','header')?.detail}}</h5>
          </div>
          <div class="table-pdf-title__right">
            @if (hasConditions() && !pdfDoc) {
              <p>The full list of Conditions can be found <a href="#anchor-conditions" data-scrollto="true" data-scrolltooffset="80">here</a>.</p>
            }
            @if (hasConditions() && pdfDoc) {
              <p>The full list of Conditions can be found on <a href="#anchor-conditions" data-anchor-scroll="">page <span class="pdf-page-x" data-target="anchor-conditions"></span></a>.</p>
            }
          </div>
        </div>
        <div class="table-pdf-wrap">
          <table class="table table--pdf">
            <thead>
              <tr>
                <th class="cell-label">Detail</th>
                <th>Provider</th>
                @if (summaryHasColumn(policySummaryAlt, 'limit')) {
                  <th class="cell-centered">Limit</th>
                }
                @if (summaryHasColumn(policySummaryAlt, 'basis')) {
                  <th class="cell-centered">Basis</th>
                }
                <th class="cell-centered">Excess</th>
                <th class="cell-right">Premium</th>
              </tr>
            </thead>
            <tbody>
              @if (coverAltRow('policy','sub_header')) {
                <tr>
                  <th [attr.colspan]="summaryColspan(policySummaryAlt)" class="cell-pdf-sub">
                    <div class="table-label">
                      <img [src]="coverAltRow('policy','sub_header')?.img_path" class="icon"> {{coverAltRow('policy','sub_header')?.detail}}
                    </div>
                  </th>
                </tr>
              }
              @for (item of coverAltRows('policy','entity'); track item) {
                <tr>
                  <td class="cell-label cell-medium">{{item?.detail}}</td>
                  <td>{{item?.provider}}</td>
                  @if (summaryHasColumn(policySummaryAlt, 'limit')) {
                    <td class="cell-centered">{{item?.limit}}</td>
                  }
                  @if (summaryHasColumn(policySummaryAlt, 'basis')) {
                    <td class="cell-centered">{{item?.basis}}</td>
                  }
                  <td class="cell-centered">{{item?.excess}}</td>
                  <td class="cell-right cell-value"><strong>{{item?.premium}}</strong>/{{item?.frequency_short}}</td>
                </tr>
              }
              @if (coverAltRow('class','sub_header')) {
                <tr>
                  <th [attr.colspan]="summaryColspan(policySummaryAlt)" class="cell-pdf-sub">
                    <div class="table-label">
                      <img [src]="coverAltRow('class','sub_header')?.img_path" class="icon"> {{coverAltRow('class','sub_header')?.detail}}
                    </div>
                  </th>
                </tr>
              }
              @for (classRow of getPolicySummaryAltClasses(); track classRow) {
                <tr>
                  <th [attr.colspan]="summaryColspan(policySummaryAlt)" class="cell-pdf-sub">
                    <div class="table-label">
                      <img [src]="classRow?.img_path" class="icon"> {{classRow?.detail}}
                    </div>
                  </th>
                </tr>
                @for (item of getPolicySummaryAltItems(classRow); track item) {
                  <tr>
                    <td class="cell-label cell-medium">{{item?.detail}}</td>
                    <td>{{item?.provider}}</td>
                    @if (summaryHasColumn(policySummaryAlt, 'limit')) {
                      <td class="cell-centered">{{item?.limit}}</td>
                    }
                    @if (summaryHasColumn(policySummaryAlt, 'basis')) {
                      <td class="cell-centered">{{item?.basis}}</td>
                    }
                    <td class="cell-centered">{{item?.excess}}</td>
                    <td class="cell-right cell-value"><strong>{{item?.premium}}</strong>/{{item?.frequency_short}}</td>
                  </tr>
                }
              }
              @if (summaryHasColumn(policySummaryAlt, 'limit') && coverAltRow('note','entity')?.detail) {
                <tr>
                  <td class="cell-note" [attr.colspan]="summaryColspan(policySummaryAlt)">
                    <p><strong>Note:</strong> {{coverAltRow('note','entity')?.detail}}</p>
                  </td>
                </tr>
              }
            </tbody>
          </table>
        </div>
      </div>
      }

      <div class="pdf-page__component">
        <div class="table-pdf-title" data-sticky="true">
          <div class="table-pdf-title__left">
            <img [src]="coverAltRow('premium','header')?.img_path" class="icon"><h5>{{coverAltRow('premium','header')?.detail}}</h5>
          </div>
        </div>
        <div class="pdf__tabletotal">
          <div class="pdf__tabletotal-inner">
            <div class="pdf__tabletotal-subtotals">
              <div class="pdf__tabletotal-company">
                <img [src]="coverAltRow('premium','logo')?.img_path || firstWhere(header, 'field_key', 'insurer_logo')?.value" class="img-fluid">
              </div>
              <div class="pdf__tabletotal-subtotal">
                <label>{{coverAltRow('premium','items_subtotal')?.detail}}</label>
                <p><strong>{{coverAltRow('premium','items_subtotal')?.premium}}</strong><wbr>/{{coverAltRow('premium','items_subtotal')?.frequency_short}}</p>
              </div>
              @if (coverAltRow('premium','benefits_subtotal')) {
                <div class="pdf__tabletotal-subtotal">
                  <label>{{coverAltRow('premium','benefits_subtotal')?.detail}}</label>
                  <p><strong>{{coverAltRow('premium','benefits_subtotal')?.premium}}</strong><wbr>/{{coverAltRow('premium','benefits_subtotal')?.frequency_short}}</p>
                </div>
              }
              @if (coverAltRow('premium','fees_subtotal')) {
                <div class="pdf__tabletotal-subtotal">
                  <label>{{coverAltRow('premium','fees_subtotal')?.detail}}</label>
                  <p><strong>{{coverAltRow('premium','fees_subtotal')?.premium}}</strong><wbr>/{{coverAltRow('premium','fees_subtotal')?.frequency_short}}</p>
                </div>
              }
              @if (coverAltRow('premium','sasria_subtotal')) {
                <div class="pdf__tabletotal-subtotal">
                  <label>{{coverAltRow('premium','sasria_subtotal')?.detail}}</label>
                  <p><strong>{{coverAltRow('premium','sasria_subtotal')?.premium}}</strong><wbr>/{{coverAltRow('premium','sasria_subtotal')?.frequency_short}}</p>
                </div>
              }
            </div>
            <div class="pdf__tabletotal-total">
              <div class="pdf__tabletotal-label">
                <label>{{coverAltRow('premium','policy_premium_total')?.detail}}</label>
              </div>
              <div class="pdf__tabletotal-details">
                <div class="pdf__tabletotal-cost">
                  <p><strong>{{coverAltRow('premium','policy_premium_total')?.premium}}</strong><wbr>/{{coverAltRow('premium','policy_premium_total')?.frequency_short}}</p>
                </div>
                <div class="pdf__tabletotal-text">
                  <small>{{coverAltRow('premium','taxes')?.detail}}<strong>{{coverAltRow('premium','taxes')?.premium}}</strong></small>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      @if (pdfDoc) {
        <footer class="pdf-page__footer">
          <div class="pdf-page__footer-inner">
            <img src="assets/0/logo.svg" alt="Everything.Insure">
            <p><strong>Questions?</strong> Contact Everything.Insure at <a href="mailto:{{footer?.support_email || 'help@everything.insure'}}">{{footer?.support_email || 'help@everything.insure'}}</a> or call <strong>{{footer?.support_phone || '0870952823'}}</strong></p>
            <div><a href="#anchor-index" data-anchor-scroll="">Back to contents</a></div>
            <div><span class="pdf-page-num"></span></div>
          </div>
        </footer>
      }
    </section>
    }

    <!-- Benefits Summary: grouped by class -> item -> benefits -->
    @if (pdfDoc && benefitSummary?.length > 0) {
      <section class="pdf-page pdf-page--section" data-title="Benefits Summary" id="anchor-benefits-summary">
        <div class="pdf-page__component">
          <header class="pdf__coverhead">
            <div class="pdf__coverhead-logo">
              <span><img [src]="firstWhere(header, 'field_key', 'platform_logo')?.value"></span>
              <span [class.pdf__coverhead-tagline]="isTaglineLogo(firstWhere(header, 'field_key', 'broker_logo')?.value)"><img [src]="firstWhere(header, 'field_key', 'broker_logo')?.value"></span>
            </div>
            <div class="pdf__coverhead-company">
              <img src="{{firstWhere(header, 'field_key', 'insurer_logo')?.value}}" class="img-fluid">
            </div>
          </header>
          <div class="pdf__cover-section">
            <div class="pdf__cover-section-bg"><img src="assets/img/home/header-everything.svg" alt=""></div>
            <div class="pdf__cover-section-badge"><img src="assets/img/docs/people-benefits.webp" alt=""></div>
            <div class="pdf__cover-section-spacer"></div>
            <div class="pdf__cover-section-content"><h1>Benefits Summary</h1></div>
          </div>
        </div>
        <footer class="pdf-page__footer">
          <div class="pdf-page__footer-inner">
            <img src="assets/0/logo.svg" alt="Everything.Insure">
            <p><strong>Questions?</strong> Contact Everything.Insure at <a href="mailto:{{footer?.support_email || 'help@everything.insure'}}">{{footer?.support_email || 'help@everything.insure'}}</a> or call <strong>{{footer?.support_phone || '0870952823'}}</strong></p>
            <div><a href="#anchor-index" data-anchor-scroll="">Back to contents</a></div>
            <div><span class="pdf-page-num"></span></div>
          </div>
        </footer>
      </section>
    }

    @if (benefitSummary?.length > 0) {
    <section [ngClass]="pdfDoc ? 'pdf-page': 'pdf-view'" [id]="!pdfDoc ? 'anchor-benefits-summary' : null" data-title="Benefits Summary">
      <div class="pdf-page__component">
        <div class="pdf-page__component-title">
          <div class="pdf-page__component-title-text">
            <h2>{{benefitSummary?.[0]?.header || 'Benefits Summary'}}</h2>
          </div>
        </div>
      </div>

      @for (group of benefitGroups(); track group) {
        <div class="pdf-page__component">
          <div class="table-pdf-title" data-sticky="true">
            <div class="table-pdf-title__left">
              <img [src]="group?.img_path" class="icon">
              <h5>{{group?.detail}}</h5>
            </div>
          </div>
          <div class="table-pdf-wrap">
            <table class="table table--pdf">
              <thead>
                <tr>
                  <th class="cell-label">Benefit</th>
                  <th>Provider</th>
                  <th class="cell-centered">Limit</th>
                  <th class="cell-centered">Type</th>
                  <th class="cell-centered">Excess</th>
                  <th class="cell-right">Premium</th>
                </tr>
              </thead>
              <tbody>
                @for (sub of benefitSubHeaders(group); track sub) {
                  <tr>
                    <th colspan="6" class="cell-pdf-sub">
                      <div class="table-label">
                        <img [src]="sub?.img_path" class="icon">
                        <strong>{{sub?.detail}}</strong>
                      </div>
                    </th>
                  </tr>
                  @for (b of benefitVaps(sub); track b) {
                    <tr>
                      <td class="cell-label cell-medium">{{b?.detail}}</td>
                      <td>{{b?.provider}}</td>
                      <td class="cell-centered">{{b?.limit}}</td>
                      <td class="cell-centered">
                        <div [ngClass]="b?.type === 'Added' ? 'indicator indicator--positive' : (b?.type === 'Included' ? 'indicator indicator--info' : 'indicator')">{{b?.type}}</div>
                      </td>
                      <td class="cell-centered">{{b?.excess}}</td>
                      <td class="cell-right cell-value"><strong>{{b?.premium}}</strong>/{{b?.frequency_short}}</td>
                    </tr>
                  }
                }
              </tbody>
            </table>
          </div>
        </div>
      }

      @if (pdfDoc) {
        <footer class="pdf-page__footer">
          <div class="pdf-page__footer-inner">
            <img src="assets/0/logo.svg" alt="Everything.Insure">
            <p><strong>Questions?</strong> Contact Everything.Insure at <a href="mailto:{{footer?.support_email || 'help@everything.insure'}}">{{footer?.support_email || 'help@everything.insure'}}</a> or call <strong>{{footer?.support_phone || '0870952823'}}</strong></p>
            <div><a href="#anchor-index" data-anchor-scroll="">Back to contents</a></div>
            <div><span class="pdf-page-num"></span></div>
          </div>
        </footer>
      }
    </section>
    }

    <!-- Benefits Summary Alternate: grouped by class -> benefit name -> items -->
    @if (pdfDoc && benefitSummaryAlt?.length > 0) {
      <section class="pdf-page pdf-page--section" data-title="Benefits Summary" id="anchor-benefits-summary">
        <div class="pdf-page__component">
          <header class="pdf__coverhead">
            <div class="pdf__coverhead-logo">
              <span><img [src]="firstWhere(header, 'field_key', 'platform_logo')?.value"></span>
              <span [class.pdf__coverhead-tagline]="isTaglineLogo(firstWhere(header, 'field_key', 'broker_logo')?.value)"><img [src]="firstWhere(header, 'field_key', 'broker_logo')?.value"></span>
            </div>
            <div class="pdf__coverhead-company">
              <img src="{{firstWhere(header, 'field_key', 'insurer_logo')?.value}}" class="img-fluid">
            </div>
          </header>
          <div class="pdf__cover-section">
            <div class="pdf__cover-section-bg"><img src="assets/img/home/header-everything.svg" alt=""></div>
            <div class="pdf__cover-section-badge"><img src="assets/img/docs/people-benefits.webp" alt=""></div>
            <div class="pdf__cover-section-spacer"></div>
            <div class="pdf__cover-section-content"><h1>Benefits Summary</h1></div>
          </div>
        </div>
        <footer class="pdf-page__footer">
          <div class="pdf-page__footer-inner">
            <img src="assets/0/logo.svg" alt="Everything.Insure">
            <p><strong>Questions?</strong> Contact Everything.Insure at <a href="mailto:{{footer?.support_email || 'help@everything.insure'}}">{{footer?.support_email || 'help@everything.insure'}}</a> or call <strong>{{footer?.support_phone || '0870952823'}}</strong></p>
            <div><a href="#anchor-index" data-anchor-scroll="">Back to contents</a></div>
            <div><span class="pdf-page-num"></span></div>
          </div>
        </footer>
      </section>
    }

    @if (benefitSummaryAlt?.length > 0) {
    <section [ngClass]="pdfDoc ? 'pdf-page': 'pdf-view'" [id]="(!pdfDoc && !benefitSummary?.length) ? 'anchor-benefits-summary' : null" data-title="Benefits Summary">
      <div class="pdf-page__component">
        <div class="pdf-page__component-title">
          <div class="pdf-page__component-title-text">
            <h2>{{benefitSummaryAlt?.[0]?.header || 'Benefits Summary'}}</h2>
          </div>
        </div>
      </div>

      @for (classRow of getBenefitAltClasses(); track classRow) {
        <div class="pdf-page__component">
          <div class="table-pdf-title" data-sticky="true">
            <div class="table-pdf-title__left">
              <img [src]="classRow?.img_path" class="icon">
              <h5>{{classRow?.detail}}</h5>
            </div>
          </div>
          <div class="table-pdf-wrap">
            <table class="table table--pdf">
              <thead>
                <tr>
                  <th class="cell-label">Item</th>
                  <th>Provider</th>
                  <th class="cell-centered">Limit</th>
                  <th class="cell-centered">Type</th>
                  <th class="cell-centered">Excess</th>
                  <th class="cell-right">Premium</th>
                </tr>
              </thead>
              <tbody>
                @for (nameRow of getBenefitAltNames(classRow); track nameRow) {
                  <tr>
                    <th colspan="6" class="cell-pdf-sub">
                      <div class="table-label">
                        <img [src]="nameRow?.img_path" class="icon">
                        <strong>{{nameRow?.detail}}</strong>
                      </div>
                    </th>
                  </tr>
                  @for (b of getBenefitAltItems(nameRow); track b) {
                    <tr>
                      <td class="cell-label cell-medium">{{b?.detail}}</td>
                      <td>{{b?.provider}}</td>
                      <td class="cell-centered">{{b?.limit}}</td>
                      <td class="cell-centered">
                        <div [ngClass]="b?.type === 'Added' ? 'indicator indicator--positive' : (b?.type === 'Included' ? 'indicator indicator--info' : 'indicator')">{{b?.type}}</div>
                      </td>
                      <td class="cell-centered">{{b?.excess}}</td>
                      <td class="cell-right cell-value"><strong>{{b?.premium}}</strong>/{{b?.frequency_short}}</td>
                    </tr>
                  }
                }
              </tbody>
            </table>
          </div>
        </div>
      }

      @if (pdfDoc) {
        <footer class="pdf-page__footer">
          <div class="pdf-page__footer-inner">
            <img src="assets/0/logo.svg" alt="Everything.Insure">
            <p><strong>Questions?</strong> Contact Everything.Insure at <a href="mailto:{{footer?.support_email || 'help@everything.insure'}}">{{footer?.support_email || 'help@everything.insure'}}</a> or call <strong>{{footer?.support_phone || '0870952823'}}</strong></p>
            <div><a href="#anchor-index" data-anchor-scroll="">Back to contents</a></div>
            <div><span class="pdf-page-num"></span></div>
          </div>
        </footer>
      }
    </section>
    }


@if (getDistinctDatasetNineClasses().length > 0) {
<!-- Insured Items: unified section, one section per class with item sub-sections -->
@if (pdfDoc) {
  <section class="pdf-page pdf-page--section" data-title="Insured Items" id="anchor-insured-items">
    <div class="pdf-page__component">
      <header class="pdf__coverhead">
        <div class="pdf__coverhead-logo">
          <span><img [src]="firstWhere(header, 'field_key', 'platform_logo')?.value"></span>
          <span [class.pdf__coverhead-tagline]="isTaglineLogo(firstWhere(header, 'field_key', 'broker_logo')?.value)"><img [src]="firstWhere(header, 'field_key', 'broker_logo')?.value"></span>
        </div>
        <div class="pdf__coverhead-company">
          <img src="{{firstWhere(header, 'field_key', 'insurer_logo')?.value}}" class="img-fluid">
        </div>
      </header>
      <div class="pdf__cover-section">
        <div class="pdf__cover-section-bg"><img src="assets/img/home/header-everything.svg" alt=""></div>
        <div class="pdf__cover-section-badge"><img src="assets/img/docs/people-insured-items.webp" alt=""></div>
        <div class="pdf__cover-section-spacer"></div>
        <div class="pdf__cover-section-content"><h1>Insured Items</h1></div>
      </div>
    </div>
    <footer class="pdf-page__footer">
      <div class="pdf-page__footer-inner">
        <img src="assets/0/logo.svg" alt="Everything.Insure">
        <p><strong>Questions?</strong> Contact Everything.Insure at <a href="mailto:{{footer?.support_email || 'help@everything.insure'}}">{{footer?.support_email || 'help@everything.insure'}}</a> or call <strong>{{footer?.support_phone || '0870952823'}}</strong></p>
        <div><a href="#anchor-index" data-anchor-scroll="">Back to contents</a></div>
        <div><span class="pdf-page-num"></span></div>
      </div>
    </footer>
  </section>
}

<section [ngClass]="pdfDoc ? 'pdf-page': 'pdf-view'" [id]="!pdfDoc ? 'anchor-insured-items' : null" data-title="Insured Items">
  <div class="pdf-page__component"
    [attr.data-sub-title]="getDistinctDatasetNineClasses()[0]"
    [id]="getDistinctDatasetNineClasses()[0] ? 'anchor-insured-items-' + constructID(getDistinctDatasetNineClasses()[0]) : null">
    <div class="pdf-page__component-title">
      <div class="pdf-page__component-title-text"><h2>{{insuredItems?.[0]?.header || 'Insured Items'}}</h2></div>
    </div>
  </div>

  @for (setNineHeaders of getDistinctDatasetNineClasses(); track setNineHeaders; let i = $index) {
    @if (getDatasetNineClassItemDetail(setNineHeaders).length > 0) {
      <!-- Class sub-section header (force page break on all except first; title/logo always show) -->
      <div class="pdf-page__component"
        [attr.data-split]="i > 0 ? 'page' : null"
        [attr.data-sub-title]="i > 0 ? setNineHeaders : null"
        [id]="i > 0 ? 'anchor-insured-items-' + constructID(setNineHeaders) : null">
        <div class="pdf-page__component-title">
          <div class="pdf-page__component-title-text"><h4>{{setNineHeaders}}</h4></div>
          <div class="pdf-page__component-logo">
            <p>This class is covered by</p>
            <div><img [src]="getClassInsurerLogo(setNineHeaders)" class="img-fluid"></div>
          </div>
        </div>
      </div>
      <!-- Items within this class -->
      @for (itemDetail of getDatasetNineClassItemDetail(setNineHeaders); track itemDetail?.item_id) {
        <div class="pdf-page__component" [attr.data-component-title]="setNineHeaders">
          <div class="table-pdf-title" data-sticky="true">
            <div class="table-pdf-title__left">
              <img src="{{getImageForClass(setNineHeaders)}}" class="icon">
              <h4>{{itemDetail?.description_1}}</h4>
            </div>
            <div class="table-pdf-title__right">
              <p class="price"><strong>{{itemDetail?.premium}}</strong>/{{itemDetail?.frequency_short}}</p>
            </div>
          </div>
          <div class="table-pdf-wrap">
            <table class="table table--pdf">
              <colgroup>
              <col class="cell-label">
              <col class="cell-description">
              <col class="cell-centered">
              <col class="cell-centered">
            </colgroup>
            <tbody>
              <!-- Key details grid -->
              <tr><td colspan="4">
                <ul class="data data--grid data--compact">
                  <li class="data__row">
                    <div class="data__cell">Start Date <strong>{{itemDetail?.start_date}}</strong></div>
                    <div class="data__cell">Limit <strong>{{itemDetail?.sum_insured}}</strong></div>
                  </li>
                  <li class="data__row">
                    <div class="data__cell">Basic Excess <strong>{{itemDetail?.excess}}</strong></div>
                    <div class="data__cell">Basis <strong>{{itemDetail?.basis}}</strong></div>
                  </li>
                </ul>
              </td></tr>
              <!-- Transcript Highlights -->
              @if (getDatasetNineClassItemTranscript(setNineHeaders, itemDetail?.item_id).length > 0) {
                <tr>
                  <th colspan="4" class="cell-pdf-sub">
                    <div class="table-label">
                      <img src="assets/icn/products/claim-documents.svg" class="icon">
                      <strong>Transcript Highlights</strong>
                      <small>The full transcript can be found <a href="javascript:;" [routerLink]="'/policy-transcript'" [queryParams]="getTranscriptQueryParams()" [fragment]="getTranscriptFragment(setNineHeaders)">here</a></small>
                    </div>
                  </th>
                </tr>
                <tr><td colspan="4">
                  <ul class="data">
                    @for (t of getDatasetNineClassItemTranscript(setNineHeaders, itemDetail?.item_id); track $index) {
                      <li class="data__row">
                        <label class="data__label">{{t?.question_prompt}}</label>
                        <div class="data__cell" style="white-space: pre-line">{{t?.response}}</div>
                      </li>
                    }
                  </ul>
                </td></tr>
              }
              <!-- Conditions Highlights -->
              @if (getDatasetNineClassItemWording(setNineHeaders, itemDetail?.item_id).length > 0) {
                <tr>
                  <th colspan="4" class="cell-pdf-sub">
                    <div class="table-label">
                      <img src="assets/icn/products/replacement-of-docs.svg" class="icon">
                      <strong>Conditions Highlights</strong>
                      @if (!pdfDoc) {
                        <small>The full list of Conditions can be found <a href="#anchor-conditions" data-scrollto="true" data-scrolltooffset="80">here</a></small>
                      }
                      @if (pdfDoc) {
                        <small>The full list of Conditions can be found on <a href="#anchor-conditions" data-anchor-scroll="">page <span class="pdf-page-x" data-target="anchor-conditions"></span></a></small>
                      }
                    </div>
                  </th>
                </tr>
                <tr class="thead">
                  <th class="cell-label">Name</th>
                  <th class="cell-description">Description</th>
                  <th class="cell-centered">Amount</th>
                  <th class="cell-centered">Excess</th>
                </tr>
                @for (w of getDatasetNineClassItemWording(setNineHeaders, itemDetail?.item_id); track w) {
                  @if (w?.wording_header) {
                    <tr>
                      <td class="cell-label"><strong [innerHTML]="w?.wording_header | safeHtml"></strong></td>
                      <td class="cell-description" [innerHTML]="w?.wording_body | safeHtml"></td>
                      <td class="cell-centered">{{w?.wording_amount}}</td>
                      <td class="cell-centered">{{w?.wording_excess}}</td>
                    </tr>
                  }
                }
              }
              <!-- Extensions Highlights -- stub until API provides 'Item Extension' data -->
              @if (getDatasetNineClassItemExtensions(setNineHeaders, itemDetail?.item_id).length > 0) {
                <tr>
                  <th colspan="4" class="cell-pdf-sub">
                    <div class="table-label">
                      <img src="assets/icn/products/replacement-of-docs.svg" class="icon">
                      <strong>Extensions Highlights</strong>
                      @if (!pdfDoc) {
                        <small>The full list of Extensions can be found <a href="#anchor-conditions" data-scrollto="true" data-scrolltooffset="80">here</a></small>
                      }
                      @if (pdfDoc) {
                        <small>The full list of Extensions can be found on <a href="#anchor-conditions" data-anchor-scroll="">page <span class="pdf-page-x" data-target="anchor-conditions"></span></a></small>
                      }
                    </div>
                  </th>
                </tr>
                <tr class="thead">
                  <th class="cell-label">Name</th>
                  <th class="cell-description">Description</th>
                  <th class="cell-centered">Amount</th>
                  <th class="cell-centered">Excess</th>
                </tr>
                @for (e of getDatasetNineClassItemExtensions(setNineHeaders, itemDetail?.item_id); track e) {
                  <tr>
                    <td class="cell-label"><strong [innerHTML]="e?.wording_header | safeHtml"></strong></td>
                    <td class="cell-description" [innerHTML]="e?.wording_body | safeHtml"></td>
                    <td class="cell-centered">{{e?.wording_amount}}</td>
                    <td class="cell-centered">{{e?.wording_excess}}</td>
                  </tr>
                }
              }
              <!-- Notes -->
              @if (getDatasetNineClassItemNotes(setNineHeaders, itemDetail?.item_id).length > 0) {
                <tr>
                  <th colspan="4" class="cell-pdf-sub">
                    <div class="table-label">
                      <img src="assets/icn/products/professional-indemnity.svg" class="icon">
                      <strong>Notes</strong>
                    </div>
                  </th>
                </tr>
                <tr><td colspan="4" class="cell-notes">
                  <ul class="data">
                    @for (n of getDatasetNineClassItemNotes(setNineHeaders, itemDetail?.item_id); track $index) {
                      <li class="data__row">
                        <div class="data__cell" [innerHTML]="n?.note_data | safeHtml"></div>
                      </li>
                    }
                  </ul>
                </td></tr>
              }
              <!-- Linked Benefits -->
              @if (getInsuredItemLinkedBenefits(setNineHeaders, itemDetail?.item_id)?.length > 0) {
                <tr>
                  <th colspan="4" class="cell-pdf-sub">
                    <div class="table-label">
                      <img src="assets/icn/products/general-benefit.svg" class="icon">
                      <strong>Linked Benefits</strong>
                    </div>
                  </th>
                </tr>
                <tr><td colspan="4">
                  <div class="pdf__benefits-list">
                    <ul class="list-unstyled">
                      @for (b of getInsuredItemLinkedBenefits(setNineHeaders, itemDetail?.item_id); track $index) {
                        <li>
                          <img src="{{b?.img_path}}" class="icon"> {{b?.vaps_name}}
                        </li>
                      }
                    </ul>
                  </div>
                </td></tr>
              }
            </tbody>
          </table>
        </div>
      </div>
    }
  }
}

@if (pdfDoc) {
  <footer class="pdf-page__footer">
    <div class="pdf-page__footer-inner">
      <img src="assets/0/logo.svg" alt="Everything.Insure">
      <p><strong>Questions?</strong> Contact Everything.Insure at <a href="mailto:{{footer?.support_email || 'help@everything.insure'}}">{{footer?.support_email || 'help@everything.insure'}}</a> or call <strong>{{footer?.support_phone || '0870952823'}}</strong></p>
      <div><a href="#anchor-index" data-anchor-scroll="">Back to contents</a></div>
      <div><span class="pdf-page-num"></span></div>
    </div>
  </footer>
}
</section>
}

<!-- Conditions -->
@if (pdfDoc) {
  <section class="pdf-page pdf-page--section" data-title="Conditions" id="anchor-conditions">
    <div class="pdf-page__component">
      <header class="pdf__coverhead">
        <div class="pdf__coverhead-logo">
          <span><img [src]="firstWhere(header, 'field_key', 'platform_logo')?.value"></span>
          <span [class.pdf__coverhead-tagline]="isTaglineLogo(firstWhere(header, 'field_key', 'broker_logo')?.value)"><img [src]="firstWhere(header, 'field_key', 'broker_logo')?.value"></span>
        </div>
        <div class="pdf__coverhead-company">
          <img src="{{firstWhere(header, 'field_key', 'insurer_logo')?.value}}" class="img-fluid">
        </div>
      </header>
      <div class="pdf__cover-section">
        <div class="pdf__cover-section-bg"><img src="assets/img/home/header-everything.svg" alt=""></div>
        <div class="pdf__cover-section-badge"><img src="assets/img/docs/people-conditions.webp" alt=""></div>
        <div class="pdf__cover-section-spacer"></div>
        <div class="pdf__cover-section-content"><h1>Conditions</h1></div>
      </div>
    </div>
    <footer class="pdf-page__footer">
      <div class="pdf-page__footer-inner">
        <img src="assets/0/logo.svg" alt="Everything.Insure">
        <p><strong>Questions?</strong> Contact Everything.Insure at <a href="mailto:{{footer?.support_email || 'help@everything.insure'}}">{{footer?.support_email || 'help@everything.insure'}}</a> or call <strong>{{footer?.support_phone || '0870952823'}}</strong></p>
        <div><a href="#anchor-index" data-anchor-scroll="">Back to contents</a></div>
        <div><span class="pdf-page-num"></span></div>
      </div>
    </footer>
  </section>
}

@if (hasConditions()) {
  <section [ngClass]="pdfDoc ? 'pdf-page': 'pdf-view'" [id]="!pdfDoc ? 'anchor-conditions' : null" data-title="Conditions">
    <div class="pdf-page__component">
      <div class="pdf-page__component-title">
        <div class="pdf-page__component-title-text">
          <h2>Conditions</h2>
        </div>
      </div>
    </div>
    <!-- Main Cover Quote Conditions -->
    <div class="pdf-page__component">
      <div class="table-pdf-title" data-sticky="true">
        <div class="table-pdf-title__left">
          <img src="assets/icn/products/general.svg" class="icon"><h5>Main Cover Quote Conditions</h5>
        </div>
      </div>
      <div class="table-pdf-wrap">
        <table class="table table--pdf table--pdf-splittable">
          <tbody>
            <tr class="thead">
              <th class="cell-label">Name</th>
              <th class="cell-description">Description</th>
              <th class="cell-value cell-centered">Amount</th>
              <th class="cell-value cell-centered">Excess</th>
            </tr>
            @for (wording of getPolicyWording(); track wording) {
              @if (wording?.wording_header) {
                <tr>
                  <td class="cell-label"><strong [innerHTML]="wording?.wording_header | safeHtml"></strong></td>
                  <td class="cell-description" [innerHTML]="wording?.wording_body | safeHtml"></td>
                  <td class="cell-value cell-centered">{{wording?.wording_amount}}</td>
                  <td class="cell-value cell-centered">{{wording?.wording_excess}}</td>
                </tr>
              }
            }
          </tbody>
        </table>
      </div>
    </div>
    <!-- Class conditions -->
    @for (setNineHeaders of distinctDatasetNineHeaders$ | async; track setNineHeaders) {
      @if (getDatasetNineClassWording(setNineHeaders).length > 0 || getDatasetNineClassNotes(setNineHeaders).length > 0) {
        <div class="pdf-page__component">
          <div class="table-pdf-title" data-sticky="true">
            <div class="table-pdf-title__left">
              <img src="{{getImageForClass(setNineHeaders)}}" class="icon"><h5>{{setNineHeaders}} Conditions</h5>
            </div>
          </div>
          <div class="table-pdf-wrap">
            <table class="table table--pdf table--pdf-splittable">
              <tbody>
                <tr class="thead">
                  <th class="cell-label">Name</th>
                  <th class="cell-description">Description</th>
                  <th class="cell-value cell-centered">Amount</th>
                  <th class="cell-value cell-centered">Excess</th>
                </tr>
                @for (note of getDatasetNineClassNotes(setNineHeaders); track note) {
                  @if (note?.wording_header) {
                    <tr>
                      <td class="cell-label"><strong [innerHTML]="note?.wording_header | safeHtml"></strong></td>
                      <td class="cell-description" [innerHTML]="note?.note_data | safeHtml"></td>
                      <td class="cell-value cell-centered" [innerHTML]="note?.wording_amount | safeHtml"></td>
                      <td class="cell-value cell-centered" [innerHTML]="note?.wording_excess | safeHtml"></td>
                    </tr>
                  }
                }
                @for (wording of getDatasetNineClassWording(setNineHeaders); track wording) {
                  @if (wording?.wording_header) {
                    <tr>
                      <td class="cell-label"><strong [innerHTML]="wording?.wording_header | safeHtml"></strong></td>
                      <td class="cell-description" [innerHTML]="wording?.wording_body | safeHtml"></td>
                      <td class="cell-value cell-centered">{{wording?.wording_amount}}</td>
                      <td class="cell-value cell-centered">{{wording?.wording_excess}}</td>
                    </tr>
                  }
                }
                @for (itemDetail of getDatasetNineClassItemDetail(setNineHeaders); track itemDetail?.item_id) {
                  @if (getDatasetNineClassItemWording(setNineHeaders, itemDetail?.item_id).length > 0) {
                    <tr>
                      <th colspan="4" class="cell-pdf-sub">
                        <div class="table-label">
                          <img src="{{getImageForClass(setNineHeaders)}}" class="icon">
                          <strong>{{itemDetail?.description_1}}</strong>
                        </div>
                      </th>
                    </tr>
                    @for (note of getDatasetNineClassItemNotes(setNineHeaders, itemDetail?.item_id); track $index) {
                      @if (note?.wording_header) {
                        <tr>
                          <td class="cell-label"><strong [innerHTML]="note?.wording_header | safeHtml"></strong></td>
                          <td class="cell-description" [innerHTML]="note?.note_data | safeHtml"></td>
                          <td class="cell-value cell-centered" [innerHTML]="note?.wording_amount | safeHtml"></td>
                          <td class="cell-value cell-centered" [innerHTML]="note?.wording_excess | safeHtml"></td>
                        </tr>
                      }
                    }
                    @for (itemWording of getDatasetNineClassItemWording(setNineHeaders, itemDetail?.item_id); track itemWording) {
                      @if (itemWording?.wording_header) {
                        <tr>
                          <td class="cell-label"><strong [innerHTML]="itemWording?.wording_header | safeHtml"></strong></td>
                          <td class="cell-description" [innerHTML]="itemWording?.wording_body | safeHtml"></td>
                          <td class="cell-value cell-centered">{{itemWording?.wording_amount}}</td>
                          <td class="cell-value cell-centered">{{itemWording?.wording_excess}}</td>
                        </tr>
                      }
                    }
                  }
                }
              </tbody>
            </table>
          </div>
        </div>
      }
    }
    @if (pdfDoc) {
      <footer class="pdf-page__footer">
        <div class="pdf-page__footer-inner">
          <img src="assets/0/logo.svg" alt="Everything.Insure">
          <p><strong>Questions?</strong> Contact Everything.Insure at <a href="mailto:{{footer?.support_email || 'help@everything.insure'}}">{{footer?.support_email || 'help@everything.insure'}}</a> or call <strong>{{footer?.support_phone || '0870952823'}}</strong></p>
          <div><a href="#anchor-index" data-anchor-scroll="">Back to contents</a></div>
          <div><span class="pdf-page-num"></span></div>
        </div>
      </footer>
    }
  </section>
}


<!-- Benefits conditions: -->

@if (pdfDoc && checkIfVapsWordingExists()?.length > 0) {
  <section class="pdf-page pdf-page--section" data-title="Benefits Conditions" id="anchor-benefits-conditions">
    <div class="pdf-page__component">
      <header class="pdf__coverhead">
        <div class="pdf__coverhead-logo">
          <span><img [src]="firstWhere(header, 'field_key', 'platform_logo')?.value"></span>
          <span [class.pdf__coverhead-tagline]="isTaglineLogo(firstWhere(header, 'field_key', 'broker_logo')?.value)"><img [src]="firstWhere(header, 'field_key', 'broker_logo')?.value"></span>
        </div>
        <div class="pdf__coverhead-company">
          <img src="{{firstWhere(header, 'field_key', 'insurer_logo')?.value}}" class="img-fluid">
        </div>
      </header>
      <div class="pdf__cover-section">
        <div class="pdf__cover-section-bg"><img src="assets/img/home/header-everything.svg" alt=""></div>
        <div class="pdf__cover-section-badge"><img src="assets/img/docs/people-benefits.webp" alt=""></div>
        <div class="pdf__cover-section-spacer"></div>
        <div class="pdf__cover-section-content"><h1>Benefits Conditions</h1></div>
      </div>
    </div>
    <footer class="pdf-page__footer">
      <div class="pdf-page__footer-inner">
        <img src="assets/0/logo.svg" alt="Everything.Insure">
        <p><strong>Questions?</strong> Contact Everything.Insure at <a href="mailto:{{footer?.support_email || 'help@everything.insure'}}">{{footer?.support_email || 'help@everything.insure'}}</a> or call <strong>{{footer?.support_phone || '0870952823'}}</strong></p>
        <div><a href="#anchor-index" data-anchor-scroll="">Back to contents</a></div>
        <div><span class="pdf-page-num"></span></div>
      </div>
    </footer>
  </section>
}

@if (checkIfVapsWordingExists()?.length > 0) {
  <section [ngClass]="pdfDoc ? 'pdf-page': 'pdf-view'" [id]="!pdfDoc ? 'anchor-benefits-conditions' : null" data-title="Benefits Conditions">
    <div class="pdf-page__component">
      <div class="pdf-page__component-title">
        <div class="pdf-page__component-title-text">
          <h2 id="benefits-conditions">Benefits Conditions</h2>
        </div>
      </div>
    </div>
    @for (itemDetail of getVapsWordingClasses(); track itemDetail; let vapIndex = $index) {
      @if (getDatasetTenBenefitsVapsWordingByClass(itemDetail?.class_id).length > 0) {
        <div class="pdf-page__component"
          [class]="vapIndex > 0 ? 'is-sub' : null"
          [attr.data-component-title]="itemDetail?.class_name + ' Benefits Conditions'">
          <div class="table-pdf-title" data-sticky="true">
            <div class="table-pdf-title__left">
              <img [src]="getImageForClass(itemDetail?.class_name)" alt="" class="icon">
              <h5>{{itemDetail?.class_name}} Benefits Conditions</h5>
            </div>
          </div>
          <div class="table-pdf-wrap">
            <table class="table table--pdf table--pdf-splittable">
              <thead>
                <tr class="thead">
                  <th class="cell-label">Name</th>
                  <th class="cell-description">Description</th>
                  <th class="cell-value cell-centered">Amount</th>
                  <th class="cell-value cell-centered">Excess</th>
                </tr>
              </thead>
              <tbody>
                @for (itemRow of getBenefitConditionsItems(itemDetail?.class_id); track itemRow) {
                  @if (getInsuredItemDescription(itemRow?.class_id, itemRow?.item_id); as itemDescription) {
                    <tr>
                      <th colspan="4" class="cell-pdf-sub">
                        <div class="table-label">
                          <img [src]="getImageForClass(itemDetail?.class_name)" alt="" class="icon">
                          <strong>{{itemDescription}}</strong>
                        </div>
                      </th>
                    </tr>
                  }
                  @for (item of getDatasetTenBenefitsVapsWordingByItem(itemRow?.class_id, itemRow?.item_id); track item) {
                    @for (wording of getDatasetTenBenefitsVapsWordingForItem(item?.vaps_id, itemRow?.item_id); track wording) {
                      <tr>
                        <td class="cell-label"><strong [innerHTML]="wording?.wording_header | safeHtml"></strong></td>
                        <td class="cell-description" [innerHTML]="wording?.wording_body | safeHtml"></td>
                        <td class="cell-value cell-centered">{{wording?.wording_amount}}</td>
                        <td class="cell-value cell-centered">{{wording?.wording_excess}}</td>
                      </tr>
                    }
                  }
                }
              </tbody>
            </table>
          </div>
        </div>
      }
    }
    @if (pdfDoc) {
      <footer class="pdf-page__footer">
        <div class="pdf-page__footer-inner">
          <img src="assets/0/logo.svg" alt="Everything.Insure">
          <p><strong>Questions?</strong> Contact Everything.Insure at <a href="mailto:{{footer?.support_email || 'help@everything.insure'}}">{{footer?.support_email || 'help@everything.insure'}}</a> or call <strong>{{footer?.support_phone || '0870952823'}}</strong></p>
          <div><a href="#anchor-index" data-anchor-scroll="">Back to contents</a></div>
          <div><span class="pdf-page-num"></span></div>
        </div>
      </footer>
    }
  </section>
}


<!-- Disclosure notice: -->
@if (pdfDoc) {
  <section class="pdf-page pdf-page--section" data-title="Disclosure Notice" id="anchor-disclosure-notice">
    <div class="pdf-page__component">
      <header class="pdf__coverhead">
        <div class="pdf__coverhead-logo">
          <span><img [src]="firstWhere(header, 'field_key', 'platform_logo')?.value"></span>
          <span [class.pdf__coverhead-tagline]="isTaglineLogo(firstWhere(header, 'field_key', 'broker_logo')?.value)"><img [src]="firstWhere(header, 'field_key', 'broker_logo')?.value"></span>
        </div>
        <div class="pdf__coverhead-company">
          <img src="{{firstWhere(header, 'field_key', 'insurer_logo')?.value}}" class="img-fluid">
        </div>
      </header>
      <div class="pdf__cover-section">
        <div class="pdf__cover-section-bg"><img src="assets/img/home/header-everything.svg" alt=""></div>
        <div class="pdf__cover-section-badge"><img src="assets/img/docs/people-conditions.webp" alt=""></div>
        <div class="pdf__cover-section-spacer"></div>
        <div class="pdf__cover-section-content"><h1>Disclosure Notice</h1></div>
      </div>
    </div>
    <footer class="pdf-page__footer">
      <div class="pdf-page__footer-inner">
        <img src="assets/0/logo.svg" alt="Everything.Insure">
        <p><strong>Questions?</strong> Contact Everything.Insure at <a href="mailto:{{footer?.support_email || 'help@everything.insure'}}">{{footer?.support_email || 'help@everything.insure'}}</a> or call <strong>{{footer?.support_phone || '0870952823'}}</strong></p>
        <div><a href="#anchor-index" data-anchor-scroll="">Back to contents</a></div>
        <div><span class="pdf-page-num"></span></div>
      </div>
    </footer>
  </section>
}

@if (disclosureNoticeList?.length > 0) {
  <section [ngClass]="pdfDoc ? 'pdf-page': 'pdf-view'" [id]="!pdfDoc ? 'anchor-disclosure-notice' : null" data-title="Disclosure Notice">
    @for (alwaysTopNotice of getDisclosureNotice(disclosureNoticeHeaderType.ALWAYS_ON_TOP); track alwaysTopNotice) {
      <div class="pdf-page__component">
        <div [innerHTML]="alwaysTopNotice?.description_print | safeHtml"></div>
      </div>
    }

    <app-disclosure-notice [disclosure]="disclosureNoticeList"></app-disclosure-notice>

    @for (alwaysTopNotice of getDisclosureNotice(disclosureNoticeHeaderType.ALWAYS_ON_BOTTOM); track alwaysTopNotice) {
      <div class="pdf-page__component" #lastDisclosureNotice>
        <div [innerHTML]="alwaysTopNotice?.description_print | safeHtml"></div>
      </div>
    }

    @if (pdfDoc) {
      <footer class="pdf-page__footer">
        <div class="pdf-page__footer-inner">
          <img src="assets/0/logo.svg" alt="Everything.Insure">
          <p><strong>Questions?</strong> Contact Everything.Insure at <a href="mailto:{{footer?.support_email || 'help@everything.insure'}}">{{footer?.support_email || 'help@everything.insure'}}</a> or call <strong>{{footer?.support_phone || '0870952823'}}</strong></p>
          <div><a href="#anchor-index" data-anchor-scroll="">Back to contents</a></div>
          <div><span class="pdf-page-num"></span></div>
        </div>
      </footer>
    }
  </section>
}
</div>
</div>
</div>
</main>
<div class="sidesheet sidesheet--menu" id="sidesheet">
  <div class="sidesheet__inner">

    <div class="sidesheet__body">

      <div class="has-scrollto">
        <ul class="central-nav__list list-unstyled" id="docs-nav-mobile">
          <li>
            <a href="#anchor-overview"><span>Overview</span></a>
          </li>
          <li>
            <a href="#anchor-details"><span>Details</span></a>
          </li>
          @if (coverSummary?.length > 0 || policySummaryAlt?.length > 0) {
            <li>
              <a href="#anchor-quote-summary"><span>Summary of Cover</span></a>
            </li>
          }
          @if (benefitSummary?.length > 0 || benefitSummaryAlt?.length > 0) {
            <li>
              <a href="#anchor-benefits-summary"><span>Benefits Summary</span></a>
            </li>
          }
          @if (getDistinctDatasetNineClasses().length > 0) {
            <li>
              <a href="#anchor-insured-items"><span>Insured Items</span></a>
            </li>
            @for (setNineHeaders of getDistinctDatasetNineClasses(); track setNineHeaders) {
              <li>
                <a [href]="'#anchor-insured-items-' + constructID(setNineHeaders)"><span>{{setNineHeaders}}</span></a>
              </li>
            }
          }
          @if (hasConditions()) {
            <li>
              <a href="#anchor-conditions"><span>Conditions</span></a>
            </li>
          }
          @if (checkIfVapsWordingExists()?.length > 0) {
            <li>
              <a href="#anchor-benefits-conditions"><span>Benefits Conditions</span></a>
            </li>
          }
          <li>
            <a href="#anchor-disclosure-notice"><span>Disclosure Notice</span></a>
          </li>
        </ul>
      </div>

    </div>
  </div>
</div>
<div class="sidesheet__overlay"></div>
<div class="modal fade modal--tray" id="modal-share-menu" tabindex="-1" role="dialog" aria-labelledby="modal-traymenu-more" aria-modal="true">
  <div class="modal-dialog">
    <div class="modal-content modal-traymenu">
      <div class="container">
        <div class="modal-traymenu__list list-unstyled">

          <a href="javascript:;" (click)="download()" data-dismiss="modal" class="modal-traymenu__list-item">
            <svg class="icon">
              <use xlink:href="#download"></use>
            </svg>
            <div>Download</div>
          </a>
        </div>

        <a href="#" data-dismiss="modal" class="modal-traymenu__close">
          <svg class="icon">
            <use xlink:href="#close-medium"></use>
          </svg>
          <div>Close</div>
        </a>
      </div>
    </div>
  </div>
</div>
<!-- pdf preview now uses the shared #modal-pdf-preview-service modal in app.component.html,
     wired to GlobalQuestionService.generatePDF() -->